import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/download-icon.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12 basic-section" }
const _hoisted_4 = { class: "breadcrumbs-secion" }
const _hoisted_5 = { class: "bs-left" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "go_back_icon" }, null, -1)
const _hoisted_7 = { class: "bs-right" }
const _hoisted_8 = { class: "bs-right-inner" }
const _hoisted_9 = { class: "btn-box-one" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    id: "details-header",
    class: {'top-fixed': _ctx.stickHeader}
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("p", {
                class: "goback",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goBack()))
              }, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.getGoBackText()), 1)
              ]),
              _createVNode("div", {
                class: ["header-content-wrapper", {'hide-background-item': _ctx.hideBackgroundDetails}]
              }, [
                _createVNode("h1", null, _toDisplayString(_ctx.title), 1),
                _createVNode("h6", null, [
                  _createVNode("span", {
                    class: "raw-html",
                    innerHTML: _ctx.$sanitize(_ctx.subTitle)
                  }, null, 8, ["innerHTML"])
                ])
              ], 2)
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", {
                    class: "white-btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printDetails())),
                    "data-toggle": "tooltip",
                    title: _ctx.$t('default.details_page.print')
                  }, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t("default.details_page.print")), 1),
                    _hoisted_10
                  ], 8, ["title"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}